import { AudioTrack, IAudioState, ILang } from "providers/AudioProvider/types";

export const getOneTrack = (trackId: string, state: IAudioState, lang: ILang) => {
  return state.translationTrackAll[lang]?.filter((one) => one.id === trackId)[0];
};

interface IPrepareBodyForSplit {
  oneTrack: AudioTrack;
  captions: string[];
  captionsField: "captions";
}

export const prepareBodyForSplit = ({
  oneTrack,
  captions,
  captionsField,
}: IPrepareBodyForSplit) => {
  const newTrackLength = Math.floor(oneTrack.length / captions.length);
  const startTimes: number[] = [];
  const endTimes: number[] = [];
  let start = 0;
  let end = 0;
  captions.filter((_, index) => {
    if (index === 0) {
      start = Math.floor(oneTrack.start);
      end = start + newTrackLength;
    } else if (index === captions.length - 1) {
      start = end + 1;
      end = Math.floor(oneTrack.start + oneTrack.length);
    } else {
      start = end + 1;
      end = end + newTrackLength;
    }
    startTimes.push(start);
    endTimes.push(end);
  });
  return {
    id: oneTrack["original_id"],
    folder_num: parseInt(oneTrack["folder_num"]),
    [captionsField]: captions,
    new_start_rus_milli: startTimes,
    new_end_rus_milli: endTimes,
  };
};
